<ap-modal #confirmModal [appModalId]="id" [title]="title" [style]="style" [footerStyle]="footerStyle">
    <p>{{description}}</p>
    <ng-template ngTemplate="footer">
        <ap-button [btnType]="'secondary'" (click)="cancel()" [label]="'Cancel'"></ap-button>
        <ap-button [btnType]="'primary'" (click)="confirm()" [label]="confirmLabel"></ap-button>
    </ng-template>
</ap-modal>